export default {
    init(){
        jQuery(($)=>{
            let el = $('.free-shipping');
            if (!el.length){
                return;
            }

            let isMobile = window.matchMedia('(max-width:767px)').matches;

            if (isMobile){

                el.find('.track.first').append(`<span class="block">${el.find('.track.second').html()}</span>`);

                let blocks = el.find('.block').toArray();

                let i = 1;
                el.find('.block').first().addClass('active')

                setInterval(()=>{
                    el.find('.block').removeClass('active');
                    $(blocks[i]).addClass('active');
                    i++;
                    if (i >= blocks.length){
                        i = 0;
                    }
                }, 2000)

            }else{
                setInterval(()=>{
                    el.find('.track').toggleClass('hidden');
                },3000);
            }
        });
    }
}